var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row py-3 mb-3 header-edit" }, [
    _c(
      "div",
      {
        staticClass:
          "col-12 col-lg-11 col-xl-11 col-md-11 pr-0 customer-info-wrapper"
      },
      [
        _c(
          "div",
          {
            staticClass:
              "header-background position-relative flex-column flex-lg-row flex-xl-row flex-md-row"
          },
          [
            _c(
              "div",
              {
                staticClass: "col-12 col-xl-2 col-lg-2 col-md-2 customer-name"
              },
              [
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center" },
                  [
                    _vm.canSeeCustomerInfo ||
                    _vm.$_can("customer-info-subco.show")
                      ? [
                          _c(
                            "h2",
                            {
                              staticClass: "pointer",
                              on: {
                                click: function($event) {
                                  _vm.isActive && _vm.$emit("showCustomerModal")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.job.customer.first_name) +
                                  "\n              " +
                                  _vm._s(_vm.job.customer.last_name) +
                                  "\n            "
                              )
                            ]
                          )
                        ]
                      : [
                          _c("h2", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.job.customer.first_name) +
                                "\n              " +
                                _vm._s(_vm.job.customer.last_name) +
                                "\n            "
                            )
                          ])
                        ],
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "position-relative mt-1" },
                      [
                        _vm.job.has_subscription
                          ? _c("span", {
                              staticClass:
                                "mod-icon-membership d-inline-block ml-3 pointer",
                              on: {
                                click: function($event) {
                                  _vm.showMembershipPerks = true
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showMembershipPerks
                          ? _c("MembershipPerks", {
                              on: {
                                close: function($event) {
                                  _vm.showMembershipPerks = false
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.job.recurly_subscription_id
                          ? _c("span", {
                              staticClass:
                                "mod-icon-recurly-subscription d-inline-block ml-3 pointer"
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.job.second_customer
                          ? _c("span", {
                              staticClass:
                                "fa fa-user d-inline-block ml-3 pointer",
                              on: {
                                click: function($event) {
                                  _vm.showSecondCustomerInfo = true
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.job.second_customer && _vm.showSecondCustomerInfo
                          ? _c("SecondCustomerInfo", {
                              attrs: { customer: _vm.job.second_customer },
                              on: {
                                close: function($event) {
                                  _vm.showSecondCustomerInfo = false
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _vm.canSeeCustomerInfo || _vm.$_can("customer-info-subco.show")
              ? _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-column d-lg-block d-xl-block d-md-block customer-info-content",
                    class: [
                      _vm.customerHasRated || _vm.job.status_id === 16
                        ? "col-12 col-lg-7 col-md-7 col-xl-7"
                        : "col-12 col-md-9 col-lg-9 col-xl-9"
                    ]
                  },
                  [
                    _c("small", { staticClass: "mr-4 header-icon" }, [
                      _c("span", {
                        staticClass: "mod-icon-edit mod-icon-phone",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.job.customer.phone
                              ? _vm.phoneMask.maskedPhone(
                                  _vm.job.customer.phone
                                )
                              : "No phone added"
                          ) +
                          "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("small", { staticClass: "mr-4 header-icon" }, [
                      _c("span", {
                        staticClass: "mod-icon-edit mod-icon-email",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.job.customer.email) +
                          "\n          "
                      ),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.contactEmails(),
                              expression: "contactEmails()"
                            }
                          ],
                          staticClass: "btn-status btn-active"
                        },
                        [_vm._v("+" + _vm._s(_vm.contactEmails()))]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.job.customer.customer_cards &&
                    _vm.job.customer.customer_cards.length
                      ? _c("small", { staticClass: "mr-4 header-icon" }, [
                          _c("span", {
                            staticClass: "mod-icon-edit mod-icon-cc",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _vm._v(
                            "\n          **** " +
                              _vm._s(
                                _vm.job.customer.customer_cards.find(function(
                                  c
                                ) {
                                  return c.is_default === 1
                                }).card_number
                              ) +
                              "\n        "
                          )
                        ])
                      : _c("small", { staticClass: "mr-4 header-icon" }, [
                          _c("span", {
                            staticClass: "mod-icon-edit mod-icon-cc",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _vm._v("\n          No credit card added\n        ")
                        ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.canSeeCustomerInfo || _vm.$_can("customer-info-subco.show")
              ? _c(
                  "div",
                  { staticClass: "col-1 header-icon customer-edit text-right" },
                  [
                    _vm.isActive
                      ? _c("span", {
                          staticClass: "fa fa-pencil pointer",
                          class: {
                            disabled: !_vm.hasAccess || _vm.job.is_flat_rate
                          },
                          on: { click: _vm.openCustomerModal }
                        })
                      : _vm._e()
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-2 d-flex align-items-center customer-edit justify-content-end"
              },
              [
                _vm.customerHasRated
                  ? _c("span", { staticClass: "pr-2" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.job.customer_rating.rating) +
                          "\n        "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.job.status_id === 16
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-customer-rating pointer p-1",
                        on: {
                          click: function($event) {
                            _vm.$emit("review")
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-star",
                          class: [_vm.customerHasRated ? "rated" : ""]
                        })
                      ]
                    )
                  : _vm._e()
              ]
            )
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-12 col-lg-1 col-md-1 col-xl-1 pl-1" },
      [
        _c(
          "button",
          {
            staticClass: "btn btn-secondary pull-right",
            attrs: { disabled: _vm.canLeaveNote || !_vm.hasAccess },
            on: {
              click: function($event) {
                _vm.showModalCustomerNote = !_vm.showModalCustomerNote
              }
            }
          },
          [
            _vm.job.customer_note
              ? [_vm._v("View note")]
              : [_vm._v("Add note")],
            _vm._v(" "),
            _c("i", {
              staticClass: "fa text-secondary",
              class: _vm.showModalCustomerNote
                ? "fa fa-caret-up"
                : "fa fa-caret-down",
              attrs: { "aria-hidden": "true" }
            })
          ],
          2
        ),
        _vm._v(" "),
        _vm.showModalCustomerNote
          ? _c("customer-note", {
              attrs: {
                "customer-note": _vm.customerNote,
                model: "jobs",
                "model-id": _vm.job.id,
                "note-id": _vm.job.customer_note
                  ? _vm.job.customer_note.id
                  : null,
                "user-id": _vm.userId,
                "status-name": _vm.job.status && _vm.job.status.name
              },
              on: {
                close: function($event) {
                  _vm.showModalCustomerNote = !_vm.showModalCustomerNote
                },
                ok: _vm.saveCustomerNote
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("error-field", { attrs: { errors: _vm.errors, field: "customer" } })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43b7cb80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43b7cb80","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/JobCustomerInfo.vue
// module id = null
// module chunks = 